export type SpeedPopoverOptions = {
  chipButton: HTMLButtonElement;
  chipValueEl: HTMLElement;
  popoverEl: HTMLElement;
  popoverValueEl: HTMLElement;
  sliderEl: HTMLInputElement;
  presetButtons: HTMLButtonElement[];
  formatValue?: (raw: number) => string;
};

export function defaultSpeedFormatter(raw: number): string {
  const mult = raw / 100;
  const rounded = Number.isInteger(mult) ? String(mult) : mult.toFixed(2).replace(/0$/, '');
  return `${rounded}×`;
}

export function setupSpeedPopover({
  chipButton,
  chipValueEl,
  popoverEl,
  popoverValueEl,
  sliderEl,
  presetButtons,
  formatValue = defaultSpeedFormatter,
}: SpeedPopoverOptions) {
  let isOpen = false;

  const updateValueViews = () => {
    const raw = Number(sliderEl.value || 100);
    const label = formatValue(raw);
    chipValueEl.textContent = label;
    popoverValueEl.textContent = label;

    presetButtons.forEach((btn) => {
      const v = Number(btn.dataset.speed || 0);
      btn.classList.toggle('speed-popover__preset--active', v === raw);
    });
  };

  const open = () => {
    isOpen = true;
    popoverEl.hidden = false;
    chipButton.setAttribute('aria-expanded', 'true');
    sliderEl.focus();
  };

  const close = () => {
    isOpen = false;
    popoverEl.hidden = true;
    chipButton.setAttribute('aria-expanded', 'false');
    chipButton.focus();
  };

  chipButton.addEventListener('click', (evt) => {
    evt.preventDefault();
    if (isOpen) close();
    else open();
  });


  document.addEventListener('click', (evt) => {
    if (!isOpen) return;
    const target = evt.target as Node;
    if (popoverEl.contains(target) || chipButton.contains(target)) return;
    close();
  });

  document.addEventListener('keydown', (evt) => {
    if (isOpen && evt.key === 'Escape') {
      evt.preventDefault();
      close();
    }
  });

  sliderEl.addEventListener('input', updateValueViews);

  presetButtons.forEach((btn) => {
    btn.addEventListener('click', (evt) => {
      evt.preventDefault();
      const v = Number(btn.dataset.speed || sliderEl.value);
      sliderEl.value = String(v);
      sliderEl.dispatchEvent(new Event('input', { bubbles: true }));
      updateValueViews();
    });
  });

  updateValueViews();

  return {
    isOpen: () => isOpen,
    open,
    close,
    refresh: updateValueViews,
  };
}
